import React, { useState } from 'react'

// Translation
import { useTranslation } from 'react-multi-lang'

// Redux
import { useDispatch, useSelector } from 'react-redux'
import { addExpenseTypeSlice,addExpenseType } from './AddModalSlice'

import { expensesTypesSlice } from '../ExpensesTypeSlicer'


// Components
import Modal from '../../../components/Modal/Modal'
import { InputField } from '../../../components/FormElements/FormElements'
import { SuccessMark, WhiteboxLoader } from '../../../components/Loader/Loader'

import { showExpensesTypeSlice } from '../ShowModal/ShowModalSlice'
import { havePermission } from '../../../services/hoc/permissions'
import { useNotification } from '../../../services/usenotification'

import { useAPI } from '../../../services/hoc/useAPI'
import { AxiosError } from 'axios'
interface iProps {showModal:boolean,id:number,closeModal:Function}
export default ({showModal,id,closeModal}:iProps) => {

    // Translation
    const t = useTranslation()
    const {alert,alertError500}=useNotification()
    

    // Redux
    const dispatch = useDispatch()
    const state = useSelector((state: { add_expenses_type: addExpenseType }) => state.add_expenses_type)
    
     const ENDPOINTS = useAPI()

    // Hooks
    const [showErrors, setShowErrors] = useState<boolean>(false)

    // Add receipt voucher
    const add = (e: React.FormEvent<HTMLFormElement>) => {

        e.preventDefault()
        if (
            id ?!havePermission('Edit Expense Type') :!havePermission("Add Expense Type")
        ) {
            return
        }
        if (
            !state.fields.code ||
            !state.fields.name 
          
          
        ) {
            setShowErrors(true)
            return
        }

        dispatch(addExpenseTypeSlice.actions.setIsLoading(true))

        const endpoint = id ? ENDPOINTS.expensesType().update : ENDPOINTS.expensesType().store

        endpoint({ id: id, ...state.fields })
            .then((response) => {
                dispatch(addExpenseTypeSlice.actions.setIsSuccess(true))
                  dispatch(addExpenseTypeSlice.actions.setIsLoading(false))

                setTimeout(() => {
                    toggle()
                    id ? 
                    dispatch(expensesTypesSlice.actions.updateExpensesType({...response.data.data}))
                    :
                    dispatch(expensesTypesSlice.actions.addExpensesType(
       
                        [{
                        ...response.data.data


                    }]
                    )
                
                    )

                    dispatch(showExpensesTypeSlice.actions.setIsOpen({ id: response.data.data.id??-1, isOpen: true }))
                }, 1000);
            })
            .catch((err:AxiosError)=>{
                alertError500(err)
                  dispatch(addExpenseTypeSlice.actions.setIsLoading(false))

                 dispatch(addExpenseTypeSlice.actions.setIsSuccess(false))
            })

    }

    const toggle = () => {
        dispatch(addExpenseTypeSlice.actions.setIsOpen(!state.isOpen))
        closeModal()
        dispatch(addExpenseTypeSlice.actions.init())
    }
    const handleChange= (obj:any) =>{
      if (  id ?havePermission('Edit Expense Type') :havePermission("Add Expense Type")) {
            dispatch(addExpenseTypeSlice.actions.set(obj))
        }
        else {
            let message = t("no_edit_permission")
            alert({en:message,ar:message},'info')
            
        }
    }
    //console.log('state add modal',state)

    return (
        <Modal open={showModal ||state.isOpen} toggle={toggle} padding={"10px 50px"} >

            {state.isLoading ? <WhiteboxLoader /> : ""}

            {state.isSuccess ? <SuccessMark /> : ""}

            <h2 className="text-center" style={{ margin: "0 0 20px" }}>
                {id? t("expenses_type_details"):t("add_expenses_type")}</h2>

            <form onSubmit={add} style={{ width: 400, maxWidth: "100%" }}>

                <InputField
                    label={t("name") + " *"}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleChange({ name: e.target.value })}
                    value={state.fields.name}
                    error={(showErrors && !state.fields.name) ? t("required_error") : ""} />

                <InputField
                  
                    label={t("code") + " *"}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleChange({ code: e.target.value })}
                    value={state.fields.code}
                    error={(showErrors && !state.fields.code) ? t("required_error") : ""} />

             
                <button className="button round bg-gold color-white margin-top-30" 
                style={{ padding: "0 80px", marginBottom: 5 }}>{t("submit")}</button>

            </form>

        </Modal>
    )

}